<template>
  <div class="market-vcr-index">
    <el-tabs v-model="tabsKey" type="card" :closable="false" :before-leave="onTabClick" >
      <el-tab-pane label="购卡记录">
        <div class="tab-content">
          <BuyCardRecord></BuyCardRecord>
        </div>
      </el-tab-pane>
      <el-tab-pane label="核销记录">
        <div class="tab-content">
          <CheckCancelRecord></CheckCancelRecord>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BuyCardRecord from './buyCardRecord'
import CheckCancelRecord from './checkCancelRecord'
export default {
  name: "mvcIndex2",
  components: {
    BuyCardRecord,
    CheckCancelRecord
  },
  data() {
    return {
      tabsKey: 0
    };
  },
  created () {
  },
  methods: {
    onTabClick() {

    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-vcr-index {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;

  .tab-content {
    margin-top: -30px;
  }
}
</style>
